import { apiClient } from "../config";

async function getDataAccessPolicy(programId: string) {
  const res = await apiClient.get(`/admin/programs/${programId}/data-access-policy`);
  return res.data;
}

export default getDataAccessPolicy;
